import { Box, Button, Card, Grid, newToast, Stack, Typography, useElementBreakpoints } from "@compass/core";
import { FilePanel } from "components";
import { StudentServiceTemplate } from "generated/openApi";
import produce from "immer";
import "moment-timezone";
import { useDispatch } from "react-redux";
import { setAppToast } from "redux/reducers/appSlice";
import ApiService from "services/apiService";

export const QrCodes = (props: {
  template: StudentServiceTemplate;
  setTemplate: (value: StudentServiceTemplate) => void;
}) => {
  const dispatch = useDispatch();
  const { breakpointsRef, setBreakpoints } = useElementBreakpoints();

  const generateQrCode = () => {
    ApiService.studentServiceTemplates.generateQrCode(props.template.id).then((response) => {
      props.setTemplate(
        produce(props.template, (draft) => {
          draft.newQrCodeUploadFile = response;
        })
      );
      dispatch(setAppToast(newToast("success", "QR Code generated and saved successfully.")));
      window.location.reload();
    });
  };

  const renderNewQrCode = () => {
    return props.template.newQrCodeUploadFile ? (
      <FilePanel
        fileName={props.template.newQrCodeUploadFile?.fileName}
        fileSize={props.template.newQrCodeUploadFile?.fileSize}
        fileRef={props.template.newQrCodeUploadFile?.fileRef}
        imagePreviewData={props.template.newQrCodeUploadFile?.imagePreviewData}
      />
    ) : (
      <Box display="flex" alignItems="center" justifyContent="center" height="100%">
        <Button variant="contained" onClick={generateQrCode}>
          Generate QR Code
        </Button>
      </Box>
    );
  };

  const renderOldQrCode = () => {
    if (!props.template.qrCodeUploadFile) return null;

    return (
      <FilePanel
        fileName={props.template.qrCodeUploadFile?.fileName}
        fileSize={props.template.qrCodeUploadFile?.fileSize}
        fileRef={props.template.qrCodeUploadFile?.fileRef}
        imagePreviewData={props.template.qrCodeUploadFile?.imagePreviewData}
      />
    );
  };

  return (
    <Box ref={breakpointsRef}>
      <Grid container spacing="lg">
        <Grid item xs={setBreakpoints({ md: 6, xs: 12 })}>
          <Card header="QR Code" fullHeight>
            {renderNewQrCode()}
          </Card>
        </Grid>
      </Grid>
    </Box>
  );
};
